import { ref } from 'vue'
import { throttle } from 'lodash'

let observer
let top
let headerHeight
const currentHeaderHeight = ref()

const hideStickyHeader = ref(false)
let timer

const stickyScroll = throttle(function (header) {
  const currentTop = window.scrollY
  const diff = (headerHeight + 5) * -1
  currentHeaderHeight.value = headerHeight

  if (top < currentTop || hideStickyHeader.value === true) {
    if (currentTop > headerHeight) {
      header.style.cssText = `transform: translateY(${diff}px)`
      header.style.setProperty('--stickyFiltersDiff', diff + headerHeight)
      currentHeaderHeight.value = 0
    }
  } else if (top > currentTop && hideStickyHeader.value === false) {
    header.style.cssText = null
    header.style.setProperty('--stickyFiltersDiff', diff - 15)
    currentHeaderHeight.value = headerHeight
  }
  top = currentTop

  // scrollovani ukonceno
  clearTimeout(timer)
  timer = setTimeout(() => {
    hideStickyHeader.value = false
  }, 500)

  // 500 je tak akorat
}, 250)

export default {
  install(Vue) {
    Vue.directive('sticky-header', {
      mounted: function (el, binding) {
        const defaults = { bodyPadding: true }
        const options = binding.value

        const settings = { ...defaults, ...options }

        observer = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            if (settings.bodyPadding) {
              document.body.style.setProperty(
                'padding-top',
                entry.contentRect.height + 'px'
              )
            }

            currentHeaderHeight.value = headerHeight = entry.contentRect.height
          })
        })

        observer.observe(el)

        top = window.scrollY
        el._scrollCallback = () => stickyScroll(el)
        window.addEventListener('scroll', el._scrollCallback)
      },
      unmounted: function (el) {
        observer.unobserve(el)
        observer.disconnect()
        window.removeEventListener('scroll', el._scrollCallback)
      }
    })
  }
}

export { currentHeaderHeight, hideStickyHeader }
